<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('list.showBackground') }}
      </h3>
    </div>
    <div class="box-body">
      <background-form :editable="false" />
    </div>
  </div>
</template>

<script>
import BackgroundForm from './Form'

export default {
  name: 'Show',
  components: { BackgroundForm },
  metaInfo () {
    return {
      title: this.$t('string.showBackground'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
